import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import {
  CERTIFICATES_REPOSITORY,
  CertificatesRepository
} from '@app/domain/repositories/ptrab/certificates/certificates.repository.contract';
import { RiskyPregnancyCertificate } from '@app/entities/models/ptrab/certificates/risky-pregnancy.model';

import { CertificatesUseCases } from './certificates.use-cases.contract';

@Injectable({
  providedIn: 'root'
})
export class CertificatesUseCasesImpl implements CertificatesUseCases {
  #certificatesRepository: CertificatesRepository = inject(CERTIFICATES_REPOSITORY);

  getRiskyPregnancyList(): Observable<RiskyPregnancyCertificate[] | null> {
    return this.#certificatesRepository.getRiskyPregnancyList();
  }
}
